<template>
  <div class="publicizeList">
    <div class="banner">
      <img src="@/assets/images/kejizhuanlan.jpg" alt="">
      <div class="weizhi">
        <i class="iconfont icon-dizhi"></i> 当前位置：首页 > 科技专栏
      </div>
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="back">
          <b></b>
          <span @click="$router.go(-1)">
            <i class="iconfont icon-prev_arrow-copy"></i>返回
          </span>
        </div>

        <div class="list-box">
          <div class="item" v-for="item in lists" :key="item.id"  @click="to('/masses/detail',item.id,5)">
            <div class="item-date">
              <b>{{item.publish_time.substring(8, 10)}}</b>
              <p>{{item.publish_time.substring(0, 7)}}</p>
            </div>
            <div class="item-cont">
              <div class="item-title ovHide">{{item.title}}</div>
              <div class="item-desc ovHide">
                {{item.desc}}
              </div>
            </div>
          </div>
        </div>

        <div class="masses-pagebox ">
          <el-pagination
            :current-page.sync="search.page"
            :page-size="search.limit"
            :total="search.total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next"
            @current-change="list">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {masses_article_lst} from "@/api";

export default {
  name: "policyList",
  data() {
    return {
      type:5,
      lists:[],
      search:{
        page:1,
        limit:10,
        total:0,
      },
    }
  },
  components: {},
  created() {
    this.type = this.$route.query.type
    this.list()
  },
  methods: {
    async list(){
      let _data = await masses_article_lst(
        this.search.page,
        this.search.limit,
        this.type
      );
      this.lists = _data.data.data;
      this.search.total = _data.data.total;
    },
    searchFun(){
      this.search.page = 1
      this.list()
    },
    to(path,id,type){
      this.$router.push({
        path: path,
        query: {
          id: id,
          type:type
        }
      })
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      background-color: #ffffff;
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 30px;
      .item {
        width: 100%;
        padding: 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cecece;
        cursor: pointer;
        &:hover {
          .item-cont {
            .item-title {
              color: #0d7bff;
            }
          }
          .item-date {
            background-color: #428ffb;
            b {
              color: #ffffff;
            }
            p {
              color: #ffffff;
            }
          }
        }
        .item-cont {
          flex: 1;
          width: 0;
          height: 100px;
          padding: 12px 0;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .item-desc {
            width: 100%;
            font-size: 16px;
            color: #b3b3b3;
          }
          .item-title {
            width: 100%;
            font-size: 22px;
            color: #141c24;
          }
        }
        .item-date {
          width: 100px;
          height: 100px;
          background-color: #ffffff;
          border: solid 1px #cecece;
          display:flex;
          justify-content: center;
          flex-direction: column;
          margin-right: 30px;
          p {
            width: 100%;
            text-align: center;
            font-size: 20px;
            color: #b3b3b3;
          }
          b {
            width: 100%;
            text-align: center;
            font-size: 49px;
            color: #b3b3b3;
            line-height: 55px;
          }
        }
      }
    }
    .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      span {
        font-size: 18px;
        color: #428ffb;
        width: 105px;
        height: 45px;
        border-radius: 22px;
        border: solid 1px #428ffb;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #428ffb;
        }
      }
    }
  }
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      width: 1500px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -750px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #ffffff;
      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>


